export const NoCalendarRecurrencesIllustration =
  'https://ik.imagekit.io/duckbill/prod/Task/empty-repeated-events.png?updatedAt=1729789883408';
